import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getRoleRedirectPath } from '../../utils/roleRoutes';

export default function ProtectedRoute({ children, role, allowedRoles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  const hasAllowedRoles = Array.isArray(allowedRoles) && allowedRoles.length > 0;
  if ((hasAllowedRoles && !allowedRoles.includes(user.role)) ||
      (!hasAllowedRoles && role && user.role !== role)) {
    return <Navigate to={getRoleRedirectPath(user)} />;
  }
  return children;
}
